import InputContainer from './InputContainer';
import { useEffect } from 'react';

type SelectProps<OptionsKey, OptionsValue> = {
    className?: string;
    label?: string;
    id?: string;
    options: any;
    value?: OptionsKey;
    onChange: (value: OptionsKey) => void;
    inputClassName?: string;
};

const Select = ({
    className,
    label,
    id,
    options,
    value,
    onChange,
    inputClassName,
    ...selectProps
}) => {
    let orderedOptions = [];
    if (Array.isArray(options)) {
        orderedOptions = options;
    } else {
        Object.keys(options).forEach(k =>
            orderedOptions.push({
                label: options[k],
                value: k,
            }),
        );
    }

    function valueExists(value) {
        for (let opt of orderedOptions) {
            if (
                opt.value === value ||
                (parseInt(opt.value) === parseInt(value) && value !== 0)
            ) {
                return true;
            }
        }

        return false;
    }

    useEffect(() => {
        if (typeof value === 'undefined' || !valueExists(value)) {
            if (typeof orderedOptions[0]?.value !== 'undefined') {
                onChange(orderedOptions[0]?.value);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options, value]);

    return (
        <InputContainer className={className} label={label} id={id}>
            <select
                value={value}
                onChange={e => onChange(e.target.value as OptionsKey)}
                className={inputClassName}
                {...selectProps}
            >
                {orderedOptions.map(opt => (
                    <option
                        value={opt.value}
                        key={opt.value}
                        disabled={!!opt.disabled}
                    >
                        {opt.label}
                    </option>
                ))}
            </select>
        </InputContainer>
    );
};

export default Select;
